import React, { useState } from "react";
import { UIContext } from "@/context/ui";

export const UIProvider = ({ children }: { children: React.ReactNode }) => {
  const [sidebar, setSidebar] = useState<boolean>(
    localStorage.getItem("sidebar") === "true" || false,
  );
  const [rightSidebar, setRightSidebar] = useState<boolean>(false);
  const [chatTitle, setChatTitle] = useState<string>("");

  const handleSetSidebar = (val: boolean) => {
    setSidebar(val);
    localStorage.setItem("sidebar", String(val));
  };

  const contextValue = {
    sidebar,
    setSidebar: handleSetSidebar,
    rightSidebar,
    setRightSidebar,
    chatTitle,
    setChatTitle,
  };

  return (
    <UIContext.Provider value={contextValue}>{children}</UIContext.Provider>
  );
};
